module.exports = __webpack_public_path__ + "img/2012_tumbnail.a1d90556.webp";